export const domesticFilterParams = (flightList) => {
  let resultFilter = {
    Airline: [],
    MaxPrice: 0,
    MinPrice: 0
  };
  if (flightList?.OutboundFlights?.length > 0) {
    resultFilter.MaxPrice = flightList?.OutboundFlights[0].TotalFare;
    resultFilter.MinPrice = flightList?.OutboundFlights[0].TotalFare;
    flightList?.OutboundFlights.forEach((airlineItem, i) => {
      if (resultFilter.Airline.find(aitem => aitem.Code == airlineItem.AirlineCode) === undefined) {
        resultFilter.Airline.push({ Code: airlineItem.AirlineCode, Name: airlineItem.AirlineName });
      }
      if (resultFilter.MaxPrice < airlineItem.TotalFare) {
        resultFilter.MaxPrice = Number.isInteger(airlineItem.TotalFare) ? airlineItem.TotalFare : parseInt(airlineItem.TotalFare) + 1;
      }
      if (resultFilter.MinPrice > airlineItem.TotalFare) {
        resultFilter.MinPrice = Number.isInteger(airlineItem.TotalFare) ? airlineItem.TotalFare : parseInt(airlineItem.TotalFare) - 1;
      }
    })
  }
  if (flightList?.InboundFlights?.length > 0) {
    flightList?.InboundFlights.forEach((airlineItem, i) => {
      if (resultFilter.Airline.find(aitem => aitem.Code === airlineItem.AirlineCode) === undefined) {
        resultFilter.Airline.push({ Code: airlineItem.AirlineCode, Name: airlineItem.AirlineName });
      }
      if (resultFilter.MaxPrice < airlineItem.TotalFare) {
        resultFilter.MaxPrice = Number.isInteger(airlineItem.TotalFare) ? airlineItem.TotalFare : parseInt(airlineItem.TotalFare) + 1;
      }
      if (resultFilter.MinPrice > airlineItem.TotalFare) {
        resultFilter.MinPrice = Number.isInteger(airlineItem.TotalFare) ? airlineItem.TotalFare : parseInt(airlineItem.TotalFare) - 1;
      }
    })
  }

  return resultFilter;
}